export const EXPERIMENTS_SCOPE = 'some-scope'; //TODO: Change me!!!
